import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchOrders } from "../../store/reducers/createProfile/apithunk";
import rollbar from "../../rollbarConfig";

export function useOrderManagemnt(initialPageSize=10) {
  const [loading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(1);
  const [category, setCategory] = useState("new");
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [pageDetails, setPageDetails] = useState({});
  const dispatch = useDispatch();

  const searchProducts = async () => {
   
    setIsLoading(true);
    let params = `?category=${category}`

    if(search?.length > 0 && count !== 1 ) {
      setCount(1)
      return
    }

     params = params+ `&page_no=${count}&page_size=${pageSize}&order_number=${search}`
   
    try {
      const response = await dispatch(
        fetchOrders(params)
      );
      const { status, data, message } = response?.payload;

      if (status=== 200) {
        setProducts(data?.data || []); 
        setPageDetails(data?._meta || {});
      } else {
        console.log(message);
      }
    } catch (error) {
      rollbar.error("Error message", error);
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    searchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, pageSize, category, search]);

  return {
    setCount,
    setPageSize,
    setCategory,
    loading,
    products,
    count,
    pageSize,
    category,
    pageDetails,
    search, setSearch,
    searchProducts
  };
}
